import { format, parseISO } from 'date-fns';

export function replaceDateTokens(source: string): string {
  const currentDate = new Date();

  return source
    .replace(/\[current-date:custom:(.*?)\]/g, (_, formatString) =>
      format(currentDate, formatString)
    )
    .replace(/\[current-date:short\]/g, () => format(currentDate, 'MM/dd/yy - hh:mm'))
    .replace(/\[current-date:medium\]/g, () =>
      format(currentDate, 'MMM dd, yyyy - h:mma')
    )
    .replace(/\[current-date:long\]/g, () =>
      format(currentDate, 'MMMM dd, yyyy - h:mma zzz')
    )
    .replace(/\[current-date:unix\]/g, () =>
      Math.floor(currentDate.getTime() / 1000).toString()
    )
    .replace(/\[current-date:raw\]/g, () =>
      parseISO(format(currentDate, 'yyyy-MM-dd')).toString()
    )
    .replace(/\[current-date:fallback\]/g, () =>
      format(currentDate, 'EEEEEE, MM/dd/yyyy - HH:mm')
    );
}

export function replaceRandomTokens(source: string): string {
  return source.replace(/\[random:(\d+)\]/g, (_, max) =>
    Math.floor(Math.random() * parseInt(max)).toString()
  );
}

export function replaceLanguageTokens(source: string, language: any): string {
  return source
    .replace(/\[language:language\]/g, () => language.language)
    .replace(/\[language:dir\]/g, () => language.dir)
    .replace(/\[language:name\]/g, () => language.name)
    .replace(/\[language:prefix\]/g, () => language.prefix)
    .replace(/\[language:domain\]/g, () => language.domain);
}

export function replaceCurrentPageTokens(source: string, currentPage: any): string {
  return source
    .replace(/\[current-page:title\]/g, () => currentPage.title)
    .replace(/\[current-page:url\]/g, () => currentPage.url)
    .replace(/\[current-page:langcode\]/g, () => currentPage.langcode);
}

export function replaceSiteTokens(source: string, site: any): string {
  source = source.replace(/\[site:url\]/gi, site.url);
  source = source.replace(/\[site:name\]/gi, site.name);
  source = source.replace(/\[site:slogan\]/gi, site.slogan);
  source = source.replace(/\[site:mail\]/gi, site.mal);
  source = source.replace(/\[site:logo\]/gi, site.logo);
  source = source.replace(/\[site:current-page-title\]/gi, site.pageTitle);
  source = source.replace(/\[site:front-page\]/gi, site.frontPage);
  return source;
}
